<mat-form-field appearance="outline" class="dashed-border" floatLabel="never" [class.ng-valid]="errors === ''" [id]="idPrefix + '-form-field'" [subscriptSizing]="photoAction ? 'dynamic' : 'fixed'">
  <!-- Input -->
  <div class="fx-row x-center y-center">
    <div class="upload-container" [class.with-photo-action]="photoAction">
      <ng-content select="[imageNotice]" />
      <lc-file-upload #fileUpload [allowedExtensions]="allowedExtensions" [class.d-none]="formControl?.value"
        [compact]="!!photoAction" [imageUrl]="placeholderImage"
        [instructions]="placeholder" [multipleUpload]="multipleUpload"
        [photoStyle]="photoStyle" [processing]="!!uploadStatus" (uploadResult)="uploadPhoto($event)" />

      @if (formControl?.value) {
        <div class="image-border" [class.fx-column]="!photoAction" [class.x-center]="!photoAction" [class.y-center]="!photoAction">
          <!-- Image Display-->
          <div class="image-container fx-row x-center y-center">
            <img [class]="photoStyle" [src]="formControl.value">
          </div>
          @if (photoAction && canEdit) {
            <button class="image-edit-button" mat-stroked-button type="button" (click)="photoAction === 'edit' ? onEdit() : fileUpload.chooseFiles()">
              <mat-icon>{{photoAction === 'edit' ? 'edit' : 'upload'}}</mat-icon>
              {{photoAction === 'edit' ? 'Edit' : 'Replace'}}
            </button>
          }
          @if (canEdit && formControl?.value) {
            <div class="menu-button-container">
              <!-- Menu Button -->
              <button aria-label="Logo Options" color="default" mat-mini-fab type="button"
                      [class.mb-2]="!photoAction" [class.menu-button]="!photoAction" [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <!-- Dropdown Menu -->
              <mat-menu #menu="matMenu">
                @if (!photoAction && editImage?.observers?.length) {
                  <button color="primary" mat-menu-item (click)="onEdit()">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                }
                <button  color="primary" mat-menu-item (click)="fileUpload?.chooseFiles()">
                  <mat-icon>import_export</mat-icon>
                  <span>Replace</span>
                </button>
                @if (downloadUrl) {
                  <button  color="primary" mat-menu-item (click)="onDownload()">
                    <mat-icon>download</mat-icon>
                    <span>Download</span>
                  </button>
                }
                <button color="warn" mat-menu-item (click)="onDelete()">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Hidden input used to make this a valid mat-form-field-->
  <input class="d-none" lcTestId matInput [errorStateMatcher]="matcher" [formControl]="formControl">

  <!-- Hint-->
  <mat-hint class="w-100" [id]="idPrefix + '-hint'">
    {{hint}}
  </mat-hint>

  <!-- Error -->
  @if (formControl && formControl.invalid) {
    <mat-error class="mt-3" [id]="idPrefix + '-error'" [innerHTML]="errors" />
  }
</mat-form-field>
